export const iconFontAwesomeSecurityUnlockKeyhole = (
	<i className="fa-solid fa-unlock-keyhole"></i>
);
